// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + {"571":"b637e9a5","2315":"ucare-panel-chunk","3923":"ucare-widget-chunk","6298":"45e6b777"}[chunkId] + "." + {"571":"7b2a697edbbcc554","2315":"31a1932a2d8d222e","3923":"9e2de17d1afdc67d","6298":"9d37bd68fa3a7633"}[chunkId] + ".js";
};